import * as React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter as Router } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { Button, Spinner } from '@/components/Elements';
import { Notifications } from '@/components/Notifications/Notifications';
import { AuthProvider, useAuth } from '@/lib/auth';

import AppLogo from '@/assets/img/p-logo.svg';
import appCompoLoading from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import storage from '@/utils/storage';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { GOOGLE_CLIENT_ID, APP_PATH, SCOPE } from '@/config';
const ErrorFallback = (a: any, b: any) => {
  //  console.log('======>>>', a, b);

  if (a?.error?.message?.indexOf('status code 401') >= 0) {
    storage.clearToken();
    window.location.assign((window.location.origin + APP_PATH) as unknown as string);
  }

  let isSubscriptionExist = true;
  try {
    const errors = a?.error?.response?.data?.errors;
    if (errors && errors.length) {
      const code = errors[0].code;
      if (code === 'ERR123') {
        isSubscriptionExist = false;
      }
    }
  } catch (e) {
    console.log(e);
  }
  const logout = () => {
    storage.clearToken();
    window.location.assign((window.location.origin + APP_PATH) as unknown as string);
  };
  const subscribeNow = () => {
    storage.clearToken();
    window.location.assign(window.location.origin);
  };
  return (
    <div
      className="text-red-500 w-screen h-screen flex flex-col justify-center items-center px-3"
      role="alert"
    >
      {isSubscriptionExist ? (
        <>
          <h2 className="text-lg font-semibold">Ooops, something went wrong :( </h2>
          <Button
            className="mt-4"
            onClick={() => window.location.assign(window.location.origin + APP_PATH)}
          >
            Refresh
          </Button>
        </>
      ) : (
        <>
          <img src={AppLogo} className="logo-icon mb-4" />
          <h2 className="text-gray-500 text-lg font-semibold text-center">
            Your subscription is not active yet. <br /> Please contact petsked admin for support.
            <br /> If you havent subscribed yet please visit our website and subscribe.
          </h2>
          <div className="error-fallback">
            <Button className="mt-4" onClick={subscribeNow}>
              Subscribe Now
            </Button>
            <Button className="mt-4" onClick={logout}>
              Logout
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <React.Suspense
      fallback={
        <div className="flex items-center justify-center w-screen h-screen">
          <Lottie className="hw-60" animationData={appCompoLoading} />
        </div>
      }
    >
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
          <HelmetProvider>
            {process.env.NODE_ENV !== 'test' && <ReactQueryDevtools />}
            <Notifications />
            <AuthProvider>
              <Router basename={APP_PATH}>{children}</Router>
              <ToastContainer autoClose={7000} />
            </AuthProvider>
          </HelmetProvider>
        </GoogleOAuthProvider>
      </ErrorBoundary>
    </React.Suspense>
  );
};
